<template>
	<v-card>
		<v-card-title> Actualizar regantes </v-card-title>

		<v-card-text>
			<v-file-input
				accept=".xlsx, .xls"
				v-model="fileToUpload"
				truncate-length="15"
				:disabled="isLoading"
			></v-file-input>

			<v-btn
				class="primary"
				:disabled="!fileToUpload || (fileToUpload && isLoading)"
				:loading="fileToUpload && isLoading"
				@click="uploadIrrigator"
			>
				Cargar
			</v-btn>
		</v-card-text>
	</v-card>
</template>

<script>
	/* Formulario para procesar excel con los datos de los regantes.
	Cabe acotar que primero deben estar cargados los datos de
	los canales y las localidades
	*/
	import { mapActions, mapState } from 'vuex';

	export default {
		name: 'irrigator-form-add',

		data() {
			return {
				fileToUpload: null,
			};
		},

		computed: {
			...mapState({
				isLoading: state => state.systemNotification.isLoading,
			}),
		},

		methods: {
			...mapActions('irrigatorControl', ['refreshIrrigators']),

			...mapActions('filesControl', ['uploadIrrigatorData']),

			uploadIrrigator() {
				if (this.fileToUpload) {
					this.uploadIrrigatorData(this.fileToUpload).finally(() => {
						this.fileToUpload = null;
						this.refreshIrrigators();
					});
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	.add-irrigator {
		position: absolute;
		bottom: 10px;
		right: 10px;
	}
</style>
